"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var relay_hooks_1 = require("relay-hooks");
exports.useLazyLoadQueryOffline = function (gqlQuery, variables, options) {
    if (options === void 0) { options = {}; }
    var environment = relay_hooks_1.useRelayEnvironment();
    var rehydrated = environment.isRehydrated();
    var online = environment.isOnline();
    if (!rehydrated || !online) {
        options.fetchPolicy = relay_hooks_1.STORE_ONLY;
    }
    var queryResult = relay_hooks_1.useLazyLoadQuery(gqlQuery, variables, options);
    if (!rehydrated) {
        var promise = environment
            .hydrate()
            .then(function () { return undefined; })
            .catch(function (error) {
            throw error; //
        });
        if (!queryResult.data) {
            throw promise;
        }
    }
    return queryResult;
};
